/**
 * Product browse filters for SearchPage sidebar (factory / CargoPool listings).
 * These map to listing publicData: keywords (built-in), industry, category.
 */

export const INDUSTRY_FILTER_OPTIONS = [
  { option: 'clothing', label: 'Clothing & Apparel' },
  { option: 'electronics', label: 'Electronics' },
  { option: 'furniture', label: 'Furniture' },
  { option: 'food', label: 'Food & Beverages' },
  { option: 'chemicals', label: 'Chemicals' },
];

export const CATEGORY_FILTER_OPTIONS = [
  { option: 'Apparel', label: 'Apparel' },
  { option: 'Electronics', label: 'Electronics' },
  { option: 'Home', label: 'Home' },
  { option: 'Furniture', label: 'Furniture' },
  { option: 'Food & Beverage', label: 'Food & Beverage' },
  { option: 'Textile', label: 'Textile' },
  { option: 'Toys & Games', label: 'Toys & Games' },
  { option: 'Machinery', label: 'Machinery' },
  { option: 'Automotive', label: 'Automotive' },
  { option: 'Chemical', label: 'Chemical' },
  { option: 'Plastic & Rubber', label: 'Plastic & Rubber' },
  { option: 'Metal & Steel', label: 'Metal & Steel' },
];

/**
 * Listing-field filter configs (merged into listing.listingFields).
 * Used for URL param validation and SearchPage FilterComponent rendering.
 */
export const productListingFieldFilters = [
  {
    key: 'industry',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: INDUSTRY_FILTER_OPTIONS,
    filterConfig: {
      indexForSearch: true,
      showFilter: true,
      filterType: 'SelectSingleFilter',
      label: 'Industry',
      group: 'primary',
    },
    showConfig: {
      label: 'Industry',
      isDetail: true,
    },
    saveConfig: {
      label: 'Industry',
    },
  },
  {
    key: 'category',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: CATEGORY_FILTER_OPTIONS,
    filterConfig: {
      indexForSearch: true,
      showFilter: true,
      filterType: 'SelectSingleFilter',
      label: 'Category',
      group: 'primary',
    },
    showConfig: {
      label: 'Category',
      isDetail: true,
    },
    saveConfig: {
      label: 'Category',
    },
  },
  {
    key: 'moq',
    scope: 'public',
    schemaType: 'long',
    numberConfig: {
      minimum: 1,
      maximum: 1000000,
    },
    filterConfig: {
      indexForSearch: true,
      showFilter: true,
      label: 'MOQ',
      group: 'primary',
    },
    showConfig: {
      label: 'MOQ',
      isDetail: true,
    },
    saveConfig: {
      label: 'MOQ',
    },
  },
  {
    key: 'qtyPerContainer',
    scope: 'public',
    schemaType: 'long',
    numberConfig: {
      minimum: 1,
      maximum: 1000000,
    },
    filterConfig: {
      indexForSearch: true,
      showFilter: true,
      label: 'Container Capacity',
      group: 'primary',
    },
    showConfig: {
      label: 'Container Capacity',
      isDetail: true,
    },
    saveConfig: {
      label: 'Container Capacity',
    },
  },
];

/** Built-in keywords filter forced into the sidebar. */
export const productKeywordsFilter = {
  key: 'keywords',
  schemaType: 'keywords',
};
